


























































































import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'
import {AxiosResponse} from 'axios'
import {Component, Prop, Vue} from 'vue-property-decorator'
import {Loading} from '../Loading'
import http from '../../utils/http'

import '../../icons/components/file-upload'
import '../../icons/components/success'
import '../../icons/components/remove-small'

export interface FileObject {
  name: string;
  url: string;
}

@Component({
  components: {
    SvgIcon,
    Loading,
  },
})
class FileUpload extends Vue {
  /**
   * Additions options of request. Available options can be found here https://github.com/axios/axios#request-config.
   */
  @Prop({type: Object, default: () => {}, required: false})
  data!: object

  /**
   * Value of files
   */
  @Prop({type: Array, default: () => [], required: false})
  value!: FileObject[]

  /**
   * Text displayed in the middle
   */
  @Prop({type: String, default: 'Drop your image here or click to browse'})
  placeholder!: string

  /**
   * Text to place in the label of component.
   */
  @Prop({type: String, default: '', required: false})
  label!: string

  /**
   * Request URL.
   */
  @Prop({type: String, required: true})
  action!: string

  /**
   * Request headers.
   */
  @Prop({type: Object, required: false})
  headers!: object

  /**
   * Request headers
   */
  @Prop({type: [Array, String], required: false, default: () => ''})
  accept!: string[] | string

  /**
   * Hook function before uploading with the file to be uploaded as its parameter. If false is returned or a Promise is returned and then is rejected, uploading will be aborted.
   */
  @Prop({type: Function, required: false, default: () => {}})
  beforeUpload!: CallableFunction

  /**
   * Text to show when the component has an invalid state.
   */
  @Prop({type: String, required: false, default: ''})
  errorMessage!: string

  /**
   * Whether uploading multiple files is permitted.
   */
  @Prop({type: Boolean, required: false, default: false})
  multiple!: boolean

  /**
   * File Upload does not react on mouse events.
   */
  @Prop({type: Boolean, required: false, default: false})
  disabled!: boolean

  /**
   * Upload automatically
   */
  @Prop({type: Boolean, required: false, default: true})
  autoUpload!: boolean

  /**
   * Upload automatically
   */
  @Prop({type: Function, required: false, default: (response: AxiosResponse) => {
    return {
      name: response.data.path || response.data.name,
      url: response.data.url || response.data.link,
    }
  }})
  transformToFileObject!: (r: AxiosResponse) => FileObject

  isSuccessful = false
  isInvalid = false
  dragAndDropCapable = false
  isUploading = false
  files: File[] = []
  internalErrorMessage = ''
  uploadProgress = 0
  uploadedFiles: File[] = []
  count = 0
  hoverCount = 0

  mounted () {
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.determineDragAndDropCapable()
  }

  reset () {
    this.isSuccessful = false
    this.isInvalid = false
    this.isUploading = false
    this.internalErrorMessage = ''
    this.files = []
    this.uploadProgress = 0
    this.count = 0
    this.hoverCount = 0
  }

  determineDragAndDropCapable () {
    const div = document.createElement('div')
    return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div)
  }

  async validateFile () {
    this.isInvalid = false
    this.internalErrorMessage = ''
    const file = this.files[0]

    // validate file type
    if (this.accept && file) {
      if ((Array.isArray(this.accept) && this.accept.map((accept) => {
        return file.type.match(accept) !== null
      }).indexOf(true) === -1) || (typeof this.accept === 'string' && !file.type.match(this.accept))) {
        this.internalErrorMessage = 'Invalid File Type'
        this.onError(this.internalErrorMessage)

        return false
      }
    }

    // execute beforeUpload method
    try {
      const result = await this.beforeUpload(file)

      if (result === false) {
        this.onError(result)
      } else {
        this.uploadFiles()
      }
    } catch (error) {
      this.onError(error)
    }
  }

  dragEnter () {
    this.count ++
  }

  dragLeave () {
    if (this.count > 0) {
      this.count --
    }
  }

  mouseEnter () {
    this.hoverCount ++
  }

  mouseLeave () {
    if (this.hoverCount > 0) {
      this.hoverCount --
    }
  }

  get isDragOver () {
    return this.hoverCount > 0 || this.count > 0
  }

  async drop (e: any) {
    this.files = e.target.files || e.dataTransfer.files

    if (!this.files[0]) {
      return
    }

    try {
      this.onFilesChange()
      await this.validateFile()
    } catch (error) {
      console.error(error)

      this.onError(error)
    }
    this.hoverCount = 0
    this.count = 0
  }

  preview (file) {
    /**
     * User clicked on the file
     *
     * @property {array} files list of files
     */
    const link = document.createElement('a')
    link.setAttribute('target', '_blank')
    link.setAttribute('href', file.url)
    link.setAttribute('download', file.name)
    link.click()

    this.$emit('preview', file)
  }

  async uploadFiles () {
    const totalFiles = this.files.length

    if (totalFiles === 0) {
      // TODO: check why this could happen
      return null
    }

    this.isSuccessful = false

    /* Initialize the form data */
    const formData = new FormData()

    if (this.multiple) {
      /**
       * Iterate over any file sent over appending the files to the form data.
       */
      for (let i = 0; i < totalFiles; i++) {
        const file = this.files[i]

        formData.append('files[' + i + ']', file)
      }
    } else {
      formData.append('file', this.files[0])
    }

    /* Make the request to the POST `action` */
    if (this.autoUpload) {
      this.isUploading = true
      try {
        const response = await http
            .post(this.action, formData, {
              ...this.data,
              headers: {
                'Content-Type': 'multipart/form-data',
                ...this.headers,
              },

              onUploadProgress: (progressEvent) => {
                this.uploadProgress = Math.round(progressEvent.loaded * 100 / progressEvent.total)

                /**
                 * Send some progress when occurs
                 *
                 * @property {Files[]} files list of files
                 * @property {number} percentage upload percentage
                 */
                this.$emit('progress', this.files, this.uploadProgress)
              },
            })

        const file = this.transformToFileObject(response)

        /**
         * The file has been uploaded successfully
         *
         * @property {array} files list of files
         * @property {object} response the server response
         */
        // this.$emit('success', this.files, response)

        // this.uploadedFiles.push(...this.files)

        const value = this.multiple ? [...this.value] : []
        value.push(file)
        this.$emit('input', value)

        this.reset()
        this.success()
      } catch (err) {
        /**
         * @type {import("axios").AxiosError }
         */
        const error = err

        this.onError(error, this.files, error.response, error.request)
      }
      this.isUploading = false
    } else {
      const value = this.multiple ? [...this.value] : []
      value.push({name: this.files[0].name, url: ''})
      this.$emit('input', value)
    }
  }

  success () {
    this.isSuccessful = true
    setTimeout(() => {
      this.isSuccessful = false
    }, 4000)
  }

  async onFormChange (e) {
    this.files = e.target.files || e.dataTransfer.files

    if (this.files[0]) {
      this.onFilesChange()

      await this.validateFile()
    }
  }

  removeFile (elem) {
    const index = this.value.indexOf(elem)

    if (index > -1) {
      const val = [...this.value]
      val.splice(index, 1)
      this.$emit('input', val)
    }
  }

  onError (message: string | object, files?: File[], response?: AxiosResponse, request?: object) {
    /**
     * An error occured.
     *
     * @property {array} files list of files
     * @property {object} message error message
     * @property {object} response if the error was due to the HttpRequest, the server response
     * @property {object} request if the error was due to the HttpRequest, the server request
     */
    this.$emit(
        'error',
        files || this.files,
      typeof message === 'string' ? new Error(message) : message,
      response,
      request,
    )

    this.isInvalid = true
  }

  onFilesChange () {
    /**
     * Changes to files in the File Upload Form.
     *
     * @property {array} files list of files
     */
    this.$emit('filechange', this.files)
  }
}

export default FileUpload
